import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Text } from "./../Text/Text";
import { Icon } from "./../Icon/Icon";
import { Tag } from "../Tag/Tag";

export const Accordian = ({
    title = <></>,
    subtitle,
    tooltip,
    open = false,
    children = <></>,
    onChange,
    questionCount,
    Accordion_small = false,
    cssClasses,
    isSelected,
}) => {
    const [accordionopen, setAccordionOpen] = useState(open);

    useEffect(() => {
        setAccordionOpen(open);
    }, [open]);

    const HeaderTag = Accordion_small ? "div" : "h3";
    const MinimizeIcon = Accordion_small ? "chevron up" : "minimize";
    const AddIcon = Accordion_small ? "chevron" : "add";

    return (
        <>
            {accordionopen ? (
                <div
                    className={`accordian-wrapper ${Accordion_small ? "accordian-small" : ""
                        } ${cssClasses ? cssClasses : ""}`}
                >
                    <div
                        className="accordian-header"
                        onClick={(e) => {
                            setAccordionOpen(!accordionopen);
                            if (onChange) {
                                onChange(e);
                            }

                        }}
                    >
                        <HeaderTag>
                            {Accordion_small ? (
                                <Text
                                    type="body-text-3"
                                    fontWeight="medium-font"
                                    children={title}
                                />
                            ) : (
                                <Text
                                    type="subtitle-1"
                                    fontWeight="medium-font"
                                    children={title}
                                />
                            )}

                            <div className="body-text body-text-1 medium-font accordian-header-subtitle">
                                {subtitle ? subtitle : ""}
                            </div>
                            {tooltip && (
                                <span onClick={(e) => { e.preventDefault(); e.stopPropagation(); }} className="info-wrap">
                                    <Icon value="information" size="medium" />
                                    <div className="tooltip-wrapper bottom-tooltip">
                                        <Text
                                            type={"body-text-2"}
                                            fontWeight={"normal-font"}
                                        >
                                            {tooltip}
                                        </Text>
                                    </div>
                                </span>
                            )}
                        </HeaderTag>

                        <div className="question-count">{questionCount}</div>
                        <div className="accordion-action d-flex">
                            {isSelected && (
                                <Tag
                                    type={"black-tag"}
                                    title={"Selected"}
                                    cssClasses={"mr-8"}
                                />
                            )}

                            {Accordion_small ? (
                                <Icon
                                    value={MinimizeIcon}
                                    colorClass={"gray-900-svg"}
                                    size="small"
                                />
                            ) : (
                                <Icon
                                    value={MinimizeIcon}
                                    colorClass={"gray-900-svg"}
                                    size="medium"
                                />
                            )}
                        </div>
                    </div>
                    <div className="accordian-body-text">{children}</div>
                </div>
            ) : (
                <div
                    className={`accordian-wrapper ${Accordion_small ? "accordian-small" : ""
                        } ${cssClasses ? cssClasses : ""}`}
                >
                    <div
                        className="accordian-header"
                        onClick={(e) => {
                            setAccordionOpen(true);
                            if (onChange) {
                                onChange(e);
                            }

                        }}
                    >
                        <HeaderTag>
                            {Accordion_small ? (
                                <Text
                                    type="body-text-3"
                                    fontWeight="medium-font"
                                    children={title}
                                />
                            ) : (
                                <Text
                                    type="subtitle-1"
                                    fontWeight="medium-font"
                                    children={title}
                                />
                            )}

                            <div className="body-text body-text-1 medium-font accordian-header-subtitle">
                                {subtitle ? subtitle : ""}
                            </div>
                            {tooltip && (
                                <span onClick={(e) => { e.preventDefault(); e.stopPropagation() }} className="info-wrap">
                                    <Icon value="information" size="medium" />
                                    <div className="tooltip-wrapper bottom-tooltip">
                                        <Text
                                            type={"body-text-2"}
                                            fontWeight={"normal-font"}
                                        >
                                            {tooltip}
                                        </Text>
                                    </div>
                                </span>
                            )}
                        </HeaderTag>

                        <div className="question-count">{questionCount}</div>
                        <div className="accordion-action d-flex">
                            {isSelected && (
                                <Tag
                                    type={"black-tag"}
                                    title={"Selected"}
                                    cssClasses={"mr-8"}
                                />
                            )}
                            {Accordion_small ? (
                                <Icon
                                    value={AddIcon}
                                    colorClass={"gray-900-svg"}
                                    size="small"
                                />
                            ) : (
                                <Icon
                                    value={AddIcon}
                                    colorClass={"gray-900-svg"}
                                    size="medium"
                                />
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

Accordian.propTypes = {
    open: PropTypes.bool,
    title: PropTypes.any,
    children: PropTypes.node,
    Accordion_small: PropTypes.bool,
};
